import BlProductCardMv from './BlProductCardMv.vue'

BlProductCardMv.install = function(Vue) {
  Vue.component(BlProductCardMv.name, BlProductCardMv)
}

export default BlProductCardMv
